import $ from "jquery";
import React from 'react'
import Webcam from "react-webcam";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next'
import LoadingGif from "../loadingGif/LoadingGif.gif"
import { setTakeWebPicture } from "../../../action/action"

const WebCamera = (props) => {

  const [loading, setLoading] = React.useState(false)
  const [clickInit, setClickInit] = React.useState(false);
  const [width, setWidth] = React.useState(null)
  const [height, setHeight] = React.useState(null)
  const [videoConstraints, setVideoConstraints] = React.useState(null)
  const [cameraPermissionGranted, setCameraPermissionGranted] = React.useState(true);

  const webcamRef = React.useRef(null);
  const capture = React.useCallback(
    () => {
      setClickInit(true);
      const imageSrc = webcamRef.current.getScreenshot();
      props.setTakeWebPicture(false)
      props.takePicture(imageSrc)
    },
    [webcamRef]
  );

  React.useEffect(() => {
    if (props.takeWebPicture == true) {
      capture()
    }
  }, [props.takeWebPicture])

  React.useEffect(() => {

    const handleOrientationChange = (firstRender) => {
      setLoading(true)

      setWidth(null);
      setHeight(null);
      setVideoConstraints(null);

      setTimeout(() => {

        if (window.screen.orientation.type == "landscape-primary" || window.screen.orientation.type == "landscape-secondary") {

          setWidth(window.innerWidth * 0.90)
          setHeight(window.innerHeight)
          setVideoConstraints((prevData) => ({
            ...prevData,
            width: window.innerWidth,
            height: window.innerHeight,
          }))
          setLoading(false)

          if(window.screen.orientation.type == "landscape-primary"){
            $("body").addClass("orientright");
          } else if (window.screen.orientation.type == "landscape-secondary") {
            $("body").addClass("orientleft");
          }

        } else {

          $("body").removeClass("orientleft");
          $("body").removeClass("orientright");

          setWidth(window.screen.width * 0.90)
          setHeight(window.screen.height)

          setVideoConstraints((prevData) => ({
            ...prevData,
            width: window.innerHeight,
            height: window.innerWidth,
          }))

          setLoading(false)
        }

      }, 500);
    }

    window.addEventListener("orientationchange", handleOrientationChange);
    handleOrientationChange();

    return () => {
      $("body").removeClass("orientleft");
      $("body").removeClass("orientright");
      window.removeEventListener("orientationchange", handleOrientationChange);
    }

  }, [])

  return loading ?

    <div style={{ position: "fixed", display: "flex", justifyContent: "center", alignItems: 'center', height: "100vh", width: "100vw" }}>
      <img src={LoadingGif} style={{ width: "50px" }} />
    </div>
    : <div className='web-cam-container'>
      {videoConstraints && width && height && <Webcam
        audio={false}
        height={height}
        screenshotFormat="image/jpeg"
        ref={webcamRef}
        width={width}
        videoConstraints={{ ...videoConstraints, facingMode: props.direction }}
        mirrored={props.direction == "user" ? true : false}
        onUserMedia={() => setCameraPermissionGranted(true)}
        onUserMediaError={() => setCameraPermissionGranted(false)}
      >
        {({ getScreenshot }) => (
          <footer style={{ zIndex: "999" }} className="button-controls footer-overlay">
            <section className="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
              <div className="form-row">
                {cameraPermissionGranted ? 
                  <p>{!props.selfie ? "Please take the picture in landscape" : ""}</p>
                  : <>We are unable to access camera. Please enable camera permission</>
                }
              </div>

              {cameraPermissionGranted && !clickInit && <button disabled={clickInit} className="primary w-100 all-caps" onClick={capture}>Take Picture</button>}
              {!cameraPermissionGranted && <button onClick={() => props.goBack()} className="primary w-100 all-caps">Return</button> }
            </section>
          </footer>
        )}
      </Webcam>}
    </div>
};

const mapStateToProps = state => {
  return {
    takeWebPicture: state.store2.takeWebPicture
  }
}

export default connect(mapStateToProps, { setTakeWebPicture })(withTranslation('translations')(WebCamera));